import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {Dialog} from "primereact/dialog";
import WorkflowfieldFormComponent from "./WorkflowfieldFormComponent";

const WorkflowfieldListComponent = (props) => {

  const [workflowfield, setWorkflowfield] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderWorkflowfieldList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/workflow_field/" + window.App.state.propsWorkflowstep.id + "/?" + JSON.stringify(lazyParams).replace('"multiSortMeta":[],', ''),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setWorkflowfield(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                type="button"
                onClick={() => {
                  window.App.setState({
                    dialogWorkflowfieldForm: true,
                    propsWorkflowfield: rowData
                  })
                }}/>
        {/*<Button icon="pi pi-trash" className="  p-button-danger"*/}
        {/*        tooltip="Törlés" tooltipOptions={{ position: 'left' }}*/}
        {/*        onClick={() => {*/}
        {/*          if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*            deleteWorkflowfield(rowData)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderWorkflowfieldList === true])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={workflowfield} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
      >
        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
        <Column field="widget" header="Widget" sortable filter filterPlaceholder="Widget" body={(rowData) => {
          return (
            <>
              {rowData.widget === 'integer' &&
              <>Egész szám</>
              }
              {rowData.widget === 'text' &&
              <>Szöveges mező</>
              }
              {rowData.widget === 'textarea' &&
              <>Hosszú szövegdoboz</>
              }
              {rowData.widget === 'float' &&
              <>Szám</>
              }
              {rowData.widget === 'option_one' &&
              <>Választható elemek - egy opció</>
              }
              {rowData.widget === 'option_multiple' &&
              <>Választható elemek - több opció</>
              }
            </>
          )
        }}></Column>
        <Column field="required" header="Kötelező" sortable filter filterPlaceholder="Kötelező" body={(rowData) => {
          return (
            <>
              {rowData.required === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-6 p-xl-6 p-col-align-center"}>

        </div>
        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
          <Button type="button" label="Új elem hozzáadása" icon="pi pi-plus" className="p-button-success"
                  onClick={() => {
                    window.App.setState({
                      dialogWorkflowfieldForm: true,
                      propsWorkflowfield: null
                    })
                  }}
          />
        </div>
      </div>
      <Dialog visible={window.App.state.dialogWorkflowfieldForm}
              style={{width: '750px'}}
              header="Elem hozzáadása"
              modal
              onHide={() => {
                window.App.setState({dialogWorkflowfieldForm: false})
              }}>
        <WorkflowfieldFormComponent  />
      </Dialog>
    </>
  )
}
export default withTranslation('common')(WorkflowfieldListComponent);
